import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { Button, Grid, makeStyles, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader.js";
import ToastModal from "views/components/ToastModal";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";
import brandTheme from "brandTheme/Theme";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import { adminPannelData } from "assets/properties/properties";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import ConfirmationModal from "views/components/ConfirmationModal";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
import CustomTextField from "components/UpdateUi/CustomeTextField";
const style = () => ({
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 2%",
    maxWidth: "29.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  header: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    fontFamily: brandTheme.font.poppins,
    margin: "2% 2% 0px 2%",
  },
  inputContainer: {},
  label: {
    fontSize: "1.2rem",
    marginLeft: ".3rem",
    marginTop: "1.1rem",
    color: brandTheme.labelColor,
    "&:focus,&:visited,&": {
      position: "absolute",
      fontSize: ".7rem",
      color: brandTheme.black,
      marginTop: "-0.4rem",
      zIndex: "1",
      background: "white",
    },
  },

  ButtomButtonContainer: {
    maxWidth: "1200px",
    margin: "45px auto 0px",
  },
  button: {
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
});
const useStyles = makeStyles(style);
const RejectApplication = ({ editable }) => {
  const classes = useStyles();
  const [loanApplicationNumber, setLoanApplicationNumber] = useState("");
  const [loanApplicationNumberState, setLoanApplicationNumberState] =
    useState("");
  const [loanId, setLoanId] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [showSearchBox, setShowSearchBox] = useState(false);

  const [selectedTableData, setSelectedTableData] = useState([]);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const GetAuctionData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_ALL_LEAD_DETAILS + loanId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result.data.error_code) {
      toastUpdate("Error", "No records found", true);
    } else {
      if (result.data.length === 0) {
        toastUpdate("Error", "No records found", true);
        setShowSearchBox(false);
      } else {
        console.log(result.data);
        if (result.data) {
          parseIndicatorData(result.data);
        }
      }
    }
  };
  const showDeleteResponse = (loanApplicationId) => {
    setConfirmationModalHeader("Reject Application");
    setConfirmationModalMsg("Are you sure you want to Reject this entry");
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickDeleteData(loanAPPLICATIONID);
  };

  const onClickDeleteData = async (id) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.REJECT_LEAD_APPLICATION + id,
      method: "PUT",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Loan application rejected successfully", true);
      setShowSearchBox(false);
    }
  };
  const GetAction = (loanApplicationId, applicationStatus) => {
    return (
      applicationStatus !== "COMPLETED" &&
      applicationStatus !== "REJECTED" && (
        <>
          <Button
            className={`${classes.button2} ${classes.button}`}
            aria-label="Delete Disbursal"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              showDeleteResponse(loanApplicationId);
            }}
          >
            Reject
          </Button>
          {/* )} */}
        </>
      )
    );
  };
  const parseIndicatorData = (data) => {
    let reportData = [];
    let row = {
      leadid: data.leadApplication?.id,
      created: data.leadApplication?.created_by,
      accountNumber: data.leadApplication?.loan_account_number,
      customerid: data.leadApplication?.customer_id,
      mobile: data.leadApplication?.mobile_number?.trim(),
      status: data.leadApplication?.status,
      action: GetAction(
        data?.leadApplication?.id,
        data.leadApplication?.status
      ),
    };
    console.log(data, row, "asdkhakdhk");
    reportData.push(row);
    setSelectedTableData(reportData);
  };
  const ValidateSearch = () => {
    if (loanId === "") {
      toastUpdate("Error", "Please fill required field", true);
      return false;
    } else {
      return true;
    }
  };
  const searchData = () => {
    if (ValidateSearch()) {
      GetAuctionData("show");
      // setShowSearchBox(true);
    }
  };
  const clearResultData = () => {
    setShowSearchBox(false);
  };
  const clearData = () => {
    setLoanId("");
    setLoanApplicationNumber("");
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader label="Reject Application" />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Lead Id"
              placeholder="Lead Id"
              value={loanId}
              onChange={(e) => setLoanId(e.target.value)}
              style={classes.inputField}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.ButtomButtonContainer}
      >
        <BottomButton
          button1="Search"
          button2="Clear Result"
          button1click={searchData}
          button2click={clearResultData}
          noButton
        />
      </Grid>
      {showSearchBox && (
        <Grid item xs={12} sm={12} md={12}>
          <ColumnGroupingTable
            columns={adminPannelData}
            rows={selectedTableData}
          />
        </Grid>
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
          rejectApplication
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

RejectApplication.propTypes = {
  editable: PropTypes.object,
};

export default withStyles(styles)(RejectApplication);
